import type { doodleChain as en } from '../en/doodle-chain';

const kindName = { prompt: '写', drawing: '画', description: '描述' } as const;

export const doodleChain: typeof en = {
  suggestions: [
    '一只骑自行车的猫',
    '一条在看牙医的龙',
    '一个在海滩上的雪人',
    '一只在点披萨的企鹅',
    '一个在遛狗的机器人',
    '一只踩滑板的乌龟',
    '一只坐电梯的长颈鹿',
    '一只在打鼓的章鱼',
    '一个在洗衣服的幽灵',
    '一头在月球上的奶牛',
    '一个在吃冰淇淋的海盗',
    '一只戴礼帽的青蛙',
    '一条在冲浪的鲨鱼',
    '一个堵在路上的巫师',
    '一只在泡澡的熊',
    '一只在荡秋千的恐龙',
    '一条在骑马的鱼',
    '一头走钢丝的大象',
    '一只在过河的鸡',
    '一棵在拥抱的仙人掌',
    '一根戴墨镜的香蕉',
    '一座在爆爆米花的火山',
    '一只在织毛衣的羊',
    '一只赢了赛跑的蜗牛',
    '一个骑小自行车的国王',
    '一只在举重的老鼠',
    '一个在逛超市的外星人',
    '一棵戴耳机的树',
    '一只在开公交车的鸭子',
    '一把在淋雨的茶壶',
    '一只从帽子里变出魔术师的兔子',
    '一头在浴缸里的鲸鱼',
    '一只在自拍的猴子',
    '一只在织围巾的蜘蛛',
    '一头在理发的狮子',
    '一只在弹吉他的螃蟹',
    '一枚奶酪做的火箭',
    '一只在打电话的蜜蜂',
    '一头在放风筝的猪',
    '一匹穿睡衣的马',
    '一朵哭出柠檬水的云',
    '一只在跑步机上的仓鼠',
    '一个在吃早餐的吸血鬼',
    '一个穿旱冰鞋的汉堡',
    '一只在看报纸的猫头鹰',
    '一只卡在箱子里的猫',
    '一个开小汽车的小丑',
    '一条在坐公交的美人鱼',
    '一只在屋顶上的山羊',
    '一个坠入爱河的三明治',
    '一个怕老鼠的骑士',
    '一盆自己浇水的植物',
    '一只背喷气背包的陆龟',
    '一块钻进睡袋的披萨',
    '一个骑摩托车的奶奶',
    '一只搬西瓜的蚂蚁',
    '一只在写作业的狗',
    '一头在雪地里的骆驼',
    '一个戴围巾的太阳',
    '一支在画自己的铅笔',
  ],
  chatPlaceholder: '说点什么…',
  waitingRoom: '等待室',
  stepOf: (step, steps) => `第 ${step} / ${steps} 步`,
  reveal: '揭晓',
  gameOver: '游戏结束',
  gameEnded: '游戏已中止',
  more: (count) => `还差 ${count} 人就能开始。`,
  needsPlayers: '传话画画至少要三个人：两个人的话，一句话只是传过去再传回来。',
  invite: (count) => `再邀请 ${count} 人。`,
  setup: (players, kinds, seconds, minutes) =>
    `${players} 人，所以共 ${kinds.length} 步：${kinds.map((kind) => kindName[kind]).join('、')}。每幅画 ${seconds} 秒；算上揭晓大约 ${minutes} 分钟。`,
  guestSetup: (players, steps, seconds) =>
    `${players} 人，所以共 ${steps} 步。每幅画 ${seconds} 秒。`,

  writeFirst: '写下第一句',
  drawThis: '画出这句话',
  whatDoesItShow: '这幅画画的是什么？',
  sitOut: '这一步你轮空',
  timesUp: '时间到！',
  everyoneDone: '大家都完成了！',
  stepSkipped: '这一步没有可做的',
  stepOver: '这一步结束了',
  skippedWhy: {
    prompt: '每条传话都往下传一位。',
    drawing: '上一步的描述都是空的，没人有字可画。',
    description: '上一步的画都是空的，没人有画可描述。',
  },
  everybody: {
    prompt: '大家都在写',
    drawing: '大家都在画',
    description: '大家都在描述',
  },
  secret: '揭晓之前，每条传话都保密。',
  drawsNext: (name) => `接下来由 ${name} 画出来。`,
  describesNext: (name) => `接下来由 ${name} 描述它。`,
  drawsYoursNext: (name) => `接下来由 ${name} 画你写的话。`,
  lastStep: '你是这条传话的最后一步。',
  endsWhenAllDone: '所有人完成时这一步就结束。',
  backIn: (step) => `第 ${step} 步你再加入。`,
  revealNext: '接下来是揭晓。',
  goesOn: {
    prompt: (name) => `你写的话会传给 ${name}。`,
    drawing: (name) => `你的画会原样传给 ${name}。`,
    description: (name) => `你的描述会传给 ${name}。`,
  },
  chainsMoveOn: '每条传话都往下传一位。',
  left: '剩余',
  toStep: (step) => `后进入第 ${step} 步`,
  toReveal: '后揭晓',
  paused: '已暂停',
  revealOf: (chain, chains) => `揭晓 · 第 ${chain} / ${chains} 条`,
  chainOf: (name) => `${name} 的传话`,
  shownOf: (shown, total) => `已展示 ${shown} / ${total}`,

  firstLine: '你的第一句',
  yourDescription: '你的描述',
  promptHelper: (length, max) =>
    `${length} / ${max} · 能画出来的都行，任何语言`,
  descriptionHelper: (length, max) => `${length} / ${max}`,
  doneWaiting: (names) => `已完成。在等 ${names}。`,
  doneAll: '已完成。大家都完成了。',
  asItIs: '时间到时，你的画会原样传下去。',
  drawFirst: '先画点什么，再按“完成”。',
  givenDrawing: '你拿到的画',
  yourDrawing: '你的画',
  nothingTo: { drawing: '没有可画的', description: '没有可描述的' },
  cameBackEmpty: {
    drawing: '你前一步的文字是空的。',
    description: '你前一步的画是空的。',
  },
  skipped: (author, reason, owner, next) =>
    `${author}${reason === 'left' ? '离开了游戏' : '没来得及完成'}，所以 ${owner} 的传话跳过这一步${next ? `，接着传给 ${next}` : next === null ? '，停在上一条' : ''}。`,
  passing: {
    prompt: '传话正在往下传。下一步：画出你拿到的话。',
    drawing: '传话正在往下传。下一步：画出你拿到的话。',
    description: '传话正在往下传。下一步：描述你拿到的画。',
  },
  passingToReveal: '传话正在往下传。下一步：揭晓。',
  doneOf: (done, of) => `${done} / ${of} 人完成`,
  stepKind: {
    prompt: (seconds) => `写，每步 ${seconds} 秒`,
    drawing: (seconds) => `画，每步 ${seconds} 秒`,
    description: (seconds) => `描述，每步 ${seconds} 秒`,
  },

  waiting: '等待中',
  statusDone: '已完成',
  working: { prompt: '在写', drawing: '在画', description: '在描述' },
  sitsOut: '这一步轮空',
  passingStatus: '往下传',
  away: '暂离',
  showing: '在揭晓传话',
  watching: '在看',
  favourite: '最受欢迎',
  heartless: '没有爱心',
  hearts: '爱心',

  verb: {
    prompt: '开了头',
    drawing: '画了它',
    description: '描述了它',
  },
  ranOutOfTime: '没来得及完成',
  leftTheGame: '离开了游戏',
  drawingBy: (name) => `${name} 的画`,
  shown: (name, verb, text) =>
    text ? `${name}${verb}：${text}` : `${name}${verb}。`,

  next: '下一条',
  nextChain: '下一条传话',
  seeAlbum: '看画册',
  moreIn: (count, owner) => `${owner} 的传话还剩 ${count} 条。`,
  lastIn: (owner) => `下一条是 ${owner} 的传话的最后一条。`,
  chainDone: (owner, next) => `${owner} 的传话看完了。接下来是 ${next} 的。`,
  allShown: '所有传话都看完了，画册里都有。',
  hostShowing: (host) => `${host} 在逐条揭晓传话。`,
  hostNext: (host, next) => `${host} 在逐条揭晓传话。接下来是 ${next} 的传话。`,
  standInReveal: (host) => `${host} 不在座位上，由你来揭晓传话。`,

  everyChain: '每条传话都在这里了。',
  soFar: '到目前为止的每条传话都在这里了。',
  endedEarly: '剩下的玩家太少，游戏提前结束了。',
  albumDetail: (chains, entries) => `${chains} 条传话，${entries} 条内容。`,
  favouriteDetail: (name, kind, hearts) =>
    `${name} 的${kind === 'prompt' ? '第一句' : kind === 'drawing' ? '画' : '描述'}最受欢迎，收到 ${hearts} 颗爱心。`,
  sharedFavourite: (count, hearts) =>
    `${count} 条内容并列最受欢迎，各收到 ${hearts} 颗爱心。`,
  noHearts: '这一局没人送爱心。',
  chains: '传话',
  albumStays: '画册会保留到下一局开始。',
};
